<template>

  <body>


    <div>
      <!--图片动态  -->
      <div class="bannerWrap">
        <div class="banner">
        <img :src="httpurl+imglist.debanner" alt title />
      </div>
      <div class="bannerText">
        <img :src=" httpurl +imglist.debannertext" alt title />
      </div>
      </div>

    </div>
  </body>
</template>
<script>
import { getbanner } from '@/api/api'
import red from '../assets/2019092409082220.png'
import { mapActions, mapGetters } from 'vuex'

export default {
     
  data () {
    return {
          imglist: {},
          httpurl:'http://shop.qdc.com/', 
    }
  },
  
    created(){

 this.getbanner();
  },
  mounted() {
  
  },

  computed: {
     
  },
  methods: { //跳转页面
  
		
   getbanner () {
     var self = this;
      var para = {
       
      };
    

      getbanner(para).then(res => {
        // console.log("banner", res.data);
       this.imglist = res.data.list
        res => {
          console.info("调用失败", res);
        };
      });
    },
  }
};
</script>

<style scoped>
@import "../../static/newlayout.css";
</style>


// WEBPACK FOOTER //
// src/views/designimg.vue